import React from 'react';

import ProgressBar from 'sharedreact/components/ProgressBar';
import Progress from 'sharedreact/data/Progress';
import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = {
  progress?: Progress,
  language?: string,
  
  onCancel?: (progressId: string) => void
};

class DropZoneProgress extends React.Component<Props> {
  constructor (props: Props) {
    super(props);

    this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
  }

  handleBeforeUnload (event: BeforeUnloadEvent) {
    if (this.props.progress != null && (this.props.progress.progress ?? 0) < 100) {
      // cancel the event as stated by the standard
      event.preventDefault();

      // Chrome requires returnValue to be set.
      event.returnValue = '';
    }
  }

  override componentDidMount (): void {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  override componentWillUnmount (): void {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  override render (): React.ReactNode {
    const { progress, language, onCancel } = this.props;

    if (progress == null) {
      return null;
    }

    const progressValue: number = Math.min(Math.max(0, Math.round(progress.progress != null ? progress.progress : 100)), 100);

    return (
      <div className='esko_dropzone-progress'>
        { language ? <span>{translate('shared.dropzone.uploading')}</span> : null }
        <span style={{float: 'right'}}>{progressValue + '%'}</span>
        <ProgressBar progress={progress} language={language} onCancel={onCancel} />
      </div>
    );
  }
}

export default DropZoneProgress;
